import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-research-committee',
  templateUrl: './research-committee.component.html',
  styleUrls: ['./research-committee.component.scss']
})
export class ResearchCommitteeComponent implements OnInit {

  constructor(
    private router: Router,
    public route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
  }

  navigate(id: any) {
    this.router.navigate(['profile', id]);
  }

}
